import { lazy } from 'react';

const routeConfig = [{
  path: '/',
  component: lazy(() => import('./Home'))
}, {
  path: '/login',
  component: lazy(() => import('./Login'))
}, {
  path: '/pricing',
  component: lazy(() => import('./ApiPricing'))
}, {
  path: '/subscription-plan',
  component: lazy(() => import('./SubscriptionPlan'))
}, {
  path: '/ecosystem',
  component: lazy(() => import('./Ecosystem'))
}, {
  path: '/voice-ai',
  component: lazy(() => import('./VoiceAI'))
}];

export default routeConfig;
